import React from 'react';
import './Cali.css'; 

const Leguizamo = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
       <h1><p className='Guabito'>Aeropuerto Puerto Leguizamo</p></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 12</th>                      
          </tr>  
          
           
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 30</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1A.pdf" target="_blank" rel="noreferrer">KALE1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1A.pdf" target="_blank" rel="noreferrer">SUMG1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1A.pdf" target="_blank" rel="noreferrer">VAKI2A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 12</th>                      
          </tr>
          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 30</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1B.pdf" target="_blank" rel="noreferrer">KALE1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1B.pdf" target="_blank" rel="noreferrer">SUMG1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/KALE1B.pdf" target="_blank" rel="noreferrer">VAKI2B</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 12</th>                      
          </tr>
          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 30</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLG/RNP30.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Leguizamo;